import { lmsKMRequest } from 'react-common'

export type Answer = {
  id: string
  answer: string // index of the answer
  normalizedScore: number
  feedback: string
  answerText?: string
}

export type ReinforcementLearningWorkflow = {
  id: string
  objectiveId: string
  answer: Answer
}

export class ReinforcementLearningWorkflowsApi {
  private static readonly getWorkflow = lmsKMRequest('users/me/reinforcement-learning-workflows/:workflowId')
  private static readonly sendWorkflowAnswer = lmsKMRequest(
    'users/me/reinforcement-learning-workflows/:workflowId/answer',
  )

  static getReinforcementLearningWorkflow(workflowId: string) {
    return this.getWorkflow
      .get<ReinforcementLearningWorkflow>({
        url: {
          workflowId,
        },
      })
      .then((res) => res.body)
  }

  static sendReinforcementLearningWorkflowAnswer(workflowId: string, answer: string) {
    return this.sendWorkflowAnswer
      .post<Answer>({
        body: { answer },
        url: {
          workflowId,
        },
        headers: {
          prefer: 'respond-sync',
        },
      })
      .then((res) => res.body)
  }
}
